import { CaseSensitive, Clipboard, Clock, ContactRound, Images, LayoutGrid, MessageCircle, ScrollText, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { CRONOS_URL, LOURI_URL, PACOCA_TRANSLATE_URL, PACOCA_PAPO_URL, PACOCA_URL, REFLEXO_URL, RITA_URL, VERSONA_URL } from "../../utils/vars";
import { isMyLove } from "../../utils/auth";
import { useAuth } from "../../contexts/auth-context";
import { System } from "../../types";
import { Map } from "react-feather";
import { Icon } from "../icon";
import { useTheme } from "../../contexts/theme-context";

interface AppsLinkPCProps {
    system?: System;
}

export function AppsLinkPC({ system }: AppsLinkPCProps ){
    const { user } = useAuth();
    const { isNewUI, isDarkMode } = useTheme();

    return (
        <li className="nav-item dropdown">
            <span className="nav-link nav-link-pc dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                <Icon invertColor={(isNewUI && !isDarkMode) || (!isNewUI && isDarkMode)}  alt="Ir para home" size={32} name="apps">
                    <LayoutGrid className='icon-menu-dark'/>
                </Icon>
            </span>
        
            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                { system !== System.pacoca && (
                    <>
                        {!isMyLove(user) && (
                            <li>
                                <Link className="dropdown-item d-flex align-items-center" target="_blank" to={PACOCA_URL}>
                                    <ContactRound style={{ height: '19px', marginRight: '3px' }}/>
                                    Paçoca
                                </Link>
                            </li>
                        )}
                    </>
                )}
                
                <li>
                    <Link className="dropdown-item d-flex align-items-center" target="_blank" rel="noreferrer" to={PACOCA_PAPO_URL}>
                        <MessageCircle style={{ height: '19px', marginRight: '3px' }}/>
                        Paçoca Papo - WhatsApp Brasileiro
                    </Link>
                </li>

                { system !== System.reflexo && (
                    <>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center" target="_blank" to={REFLEXO_URL}>
                                <Images style={{ height: '19px', marginRight: '3px' }}/>
                                Reflexo
                            </Link>
                        </li>
                    </>
                )}

                { system !== System.versona && (
                    <>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center" target="_blank" to={VERSONA_URL}>
                                <ScrollText style={{ height: '19px', marginRight: '3px' }}/>
                                Versona
                            </Link>
                        </li>
                    </>
                )}

                { system !== System.louri && (
                    <>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center" target="_blank" rel="noreferrer" to={LOURI_URL}>
                                <Sparkles style={{ height: '19px', marginRight: '3px' }}/>
                                Louri
                            </Link>
                        </li>
                    </>
                )}

                {/* { system !== System.translate && (
                    <>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center" target="_blank" to={PACOCA_TRANSLATE_URL}>
                                <CaseSensitive style={{ height: '19px', marginRight: '3px' }}/>
                                Paçoca Translate
                            </Link>
                        </li>
                    </>
                )} */}

                {/* { system !== System.rita && (
                    <>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center" target="_blank" to={RITA_URL}>
                                <Clipboard style={{ height: '19px', marginRight: '3px' }}/>
                                Rita
                            </Link>
                        </li>
                    </>
                )} */}

                {/* { system !== System.cronos && (
                    <>
                        <li>
                            <Link className="dropdown-item d-flex align-items-center" target="_blank" to={CRONOS_URL}>
                                <Clock style={{ height: '19px', marginRight: '3px' }}/>
                                Cronos
                            </Link>
                        </li>
                    </>
                )} */}
                
            </ul>
        </li>
    );
}